import styled from '@emotion/styled'

export const STitle = styled.strong`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`
